import { API_CATALOG_PREFIX } from '@shared/config/api/api-prefixes';
import { catalogBaseApi } from './base';
import {
    CatalogInfoDataRequest,
    CatalogInfoDataResponse,
    CatalogsListDataRequest,
    CatalogsListDataResponse,
    CreateCatalogDataRequest,
    CreateCatalogDataResponse,
    EditCatalogDataRequest,
    EditCatalogDataResponse,
} from './catalog-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { isEqualParameters } from '@shared/lib/utils/is-equal-parameters/is-equal-parameters';

export const catalogApi = catalogBaseApi.injectEndpoints({
    endpoints: (build) => ({
        catalogList: build.query<CatalogsListDataResponse, CatalogsListDataRequest>({
            query: (parameters) => `${API_CATALOG_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['CatalogList'],
        }),
        catalogInfinityList: build.query<CatalogsListDataResponse, CatalogsListDataRequest>({
            query: (parameters) => `${API_CATALOG_PREFIX}${queryParametersToString({ ...parameters })}`,
            serializeQueryArgs: (params) => {
                return `${params.endpointName}_${params.queryArgs.search}`;
            },
            merge: (currentCache, newItems) => {
                if (newItems.skip) {
                    currentCache.items.push(...newItems.items);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqualParameters({ currentParameters: currentArg, previousParameters: previousArg });
            },
        }),
        catalogInfo: build.query<CatalogInfoDataResponse, CatalogInfoDataRequest>({
            query: (id) => `${API_CATALOG_PREFIX}/${id}`,
        }),
        updateCatalog: build.mutation<EditCatalogDataResponse, EditCatalogDataRequest>({
            query: (data) => {
                return {
                    url: `${API_CATALOG_PREFIX}/${data.id}`,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['CatalogList'],
        }),
        createCatalog: build.mutation<CreateCatalogDataResponse, CreateCatalogDataRequest>({
            query: (data) => {
                return {
                    url: API_CATALOG_PREFIX,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['CatalogList'],
        }),
    }),
});

export const {
    useCatalogInfoQuery,
    useLazyCatalogListQuery,
    useCatalogInfinityListQuery,
    useLazyCatalogInfoQuery,
    useUpdateCatalogMutation,
    useCreateCatalogMutation,
    usePrefetch: usePrefetchCatalog,
} = catalogApi;
